<template>
  <ReviewForm
    :title="title"
    :review-type="reviewType"
    :tv-season="tvSeason"
    :tv-episode="tvEpisode"
    @close="closeModal" />
</template>

<script setup>
import ReviewForm from '@/components/ReviewForm'

const props = defineProps({
  title: Object,
  titleInfo: Object,
  userTitleInfo: Object,
  reviewType: [String, null],
  tvSeason: [Number, null],
  tvEpisode: [Number, null]
})

const emit = defineEmits(['close'])

const closeModal = () => {
  emit('close')
}
</script>
